type SolanaCluster = 'mainnet' | 'devnet';

type SolanaEnvOptions = {
  environment?: string;
  mode?: string;
  network?: string;
};

export function resolveSolanaCluster({
  environment,
  mode,
  network,
}: SolanaEnvOptions = {}): SolanaCluster {
  const normalizedNetwork = network?.trim().toLowerCase();
  if (normalizedNetwork === 'mainnet' || normalizedNetwork === 'devnet') {
    return normalizedNetwork;
  }

  const normalizedEnvironment = environment?.trim().toLowerCase();
  const normalizedMode = mode?.trim().toLowerCase();

  if (
    normalizedEnvironment === 'production' ||
    normalizedMode === 'mainnet' ||
    normalizedMode === 'production'
  ) {
    return 'mainnet';
  }

  return 'devnet';
}

const viteEnv = (import.meta.env ?? {}) as Record<
  string,
  string | boolean | undefined
>;

export const SOLANA_CLUSTER = resolveSolanaCluster({
  environment:
    typeof viteEnv.VITE_ENVIRONMENT === 'string'
      ? viteEnv.VITE_ENVIRONMENT
      : undefined,
  mode: typeof viteEnv.MODE === 'string' ? viteEnv.MODE : undefined,
  network:
    typeof viteEnv.VITE_SOLANA_NETWORK === 'string'
      ? viteEnv.VITE_SOLANA_NETWORK
      : undefined,
});
export const SOLANA_IS_MAINNET = SOLANA_CLUSTER === 'mainnet';
export const SOLANA_NETWORK_LABEL = SOLANA_IS_MAINNET ? 'Mainnet' : 'Devnet';

export function getSolanaExplorerUrl(
  path: 'address' | 'tx',
  value: string,
): string {
  return `https://explorer.solana.com/${path}/${value}?cluster=${SOLANA_CLUSTER}`;
}
